import { parseCookies } from 'nookies'

import { IUserInfoDto } from './api'
import { getAuthToken } from './auth'

const isUserAuthenticated = () => {
    const authToken = getAuthToken()
    return Boolean(authToken)
}

const isUserMissingRequiredData = (userInfo: IUserInfoDto) => {
    const { fiscalLocation } = userInfo ?? {}
    return !fiscalLocation
}

export { isUserAuthenticated, isUserMissingRequiredData }
